export enum TabIconsEnum {
  ALL = "all",
  PRODUCT = "Product",
  HOUSEHOLD = "Household",
  TECH = "Tech",
  OTHER = "Other",
  SMARTPHONE = "Smartphone",
  TABLET = "Tablet",
  ELECTRONIC = "Electronic",
  PILLS = "Pills",
  FIRSTAID = "FirstAid",
  EQUIPMENT = "Equipment",
}
